export default function (_this) {
  return {
    setDashboardModel (pathToModel, val) {
      const p = pathToModel.replace('.', '/')

      return new Promise((resolve, reject) => {
        _this.getRef('models').child(p).set(val, (err) => {
          if (err) reject()
          else resolve()
        })
      })
    },
    read (callback) {
      _this.getRef('models')
        .on('value', (snapshot) => {
          callback(snapshot.val() || {})
        })
    },
    async addDashboardModel (pathToModel, val) {
      const p = pathToModel.replace('.', '/')

      await new Promise((resolve, reject) => {
        _this.getRef('models').child(p).push(val, (err) => {
          if (err) reject()
          else resolve()
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/dashboard-models.js